export default __webpack_public_path__ + "img/eQzneYtS.b6ff7738.svg";